import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCountry: "US",
  selectCountryLangCode: "en",
  currentLanguage: "en",
  preferredLanguage: "en",
  region: "US",
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
    setSelectCountryLangCode: (state, action) => {
      state.selectCountryLangCode = action.payload;
    },
    setCurrentLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    setPreferredLanguage: (state, action) => {
      state.preferredLanguage = action.payload;
    },
    setLanguageFullName: (state, action) => {
      state.languageFullName = action.payload;
    },
    setRegion: (state, action) => {
      state.region = action.payload;
    },
  },
});

export const {
  setSelectedCountry,
  setSelectCountryLangCode,
  setCurrentLanguage,
  setPreferredLanguage,
  setLanguageFullName,
  setRegion,
} = settingsSlice.actions;
export default settingsSlice.reducer;